import { cloneDeep } from 'lodash-es'
import type { Ref } from 'vue'
import { computed, readonly, ref } from 'vue'
import type { Route } from 'vue-router'
import type VueRouter from 'vue-router'

import { useConfig } from '@/store/config'

import type { InstanceConfig } from './instance'
import { createInstanceConfig } from './instance'

export const useContext = () => {
  const config = useConfig()

  const user = ref(config.user)

  const isAdminSuper = computed(() => {
    return user.value?.role.mode === 'ADMIN_SUPER'
  })

  const isDB = (kid: string) => {
    return user.value?.db.kid === kid
  }

  return { isAdminSuper, isDB }
}

// TODO: remove when vue 3
let settings: null | InstanceConfig = null

export const useGlobalVue = () => {
  if (!settings) {
    settings = createInstanceConfig()
  }

  return { settings }
}

type UseRouteQueryOptions = {
  mode?: 'replace';
  trace?: boolean;
}

export function useRouteQuery<T extends string | string[]>(
  router: VueRouter,
  route: Route,
  name: string,
  defaultValue: T,
  options?: UseRouteQueryOptions,
) {
  const hasQuery = name in route.query

  console.log('route.query', cloneDeep(route.query))

  const query = ref<T>(defaultValue) as Ref<T>

  console.log('hasQuery', name, hasQuery)

  if (hasQuery) {
    query.value = route.query[name] as T
  }
  else {
    router.push({
      replace: options?.mode === 'replace' ?? false,
      query: {
        [name]: query.value,
      },
    })
  }

  return computed<T>({
    get() {
      return query.value
    },
    set(val) {
      if (options?.trace) {
        console.log(`useRouteQuery: ${name} changed`, val)
      }

      query.value = val
      router.push({
        replace: options?.mode === 'replace' ?? false,
        query: {
          [name]: val,
        },
      })
    },
  })
}

export function useMutableState<T>(initialState: T) {
  const state = ref<T>(initialState) as Ref<T>
  const setState = (newState: T) => {
    state.value = newState
  }

  return [state, setState] as const
}

export function useState<T>(initialState: T) {
  const [state, setState] = useMutableState(initialState)

  return [readonly(state), setState] as const
}

// export function useModelWrapper<BaseType, Path extends string>(props: BaseType, emit: SetupContext['emit'], path: Path) {
//   return computed<Get<BaseType, Path>>({
//     get() {
//       const prop = getProperty(props, path)
//       if (prop !== undefined) {
//         return prop
//       } else {
//         throw new Error(`Property ${path} does not exist in `, props)
//       }
//     },
//     set(value) {
//       const data = cloneDeep(props)
//       setProperty(data, path, value)
//       return emit(`input`, data)
//     }
//   })
// }
